import { render, staticRenderFns } from "./detailsDialog.vue?vue&type=template&id=4cb775c0&scoped=true"
import script from "./detailsDialog.vue?vue&type=script&lang=js"
export * from "./detailsDialog.vue?vue&type=script&lang=js"
import style0 from "./detailsDialog.vue?vue&type=style&index=0&id=4cb775c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb775c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cb775c0')) {
      api.createRecord('4cb775c0', component.options)
    } else {
      api.reload('4cb775c0', component.options)
    }
    module.hot.accept("./detailsDialog.vue?vue&type=template&id=4cb775c0&scoped=true", function () {
      api.rerender('4cb775c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/assess/staff/components/detailsDialog.vue"
export default component.exports